import { render, staticRenderFns } from "./BlockListInfoBoxesCustom.vue?vue&type=template&id=8ea38f38"
import script from "./BlockListInfoBoxesCustom.vue?vue&type=script&lang=js"
export * from "./BlockListInfoBoxesCustom.vue?vue&type=script&lang=js"
import style0 from "./BlockListInfoBoxesCustom.vue?vue&type=style&index=0&id=8ea38f38&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports